<style scoped>

  @media only screen and (max-width: 990px) {
    .ui.checkbox {
      margin-top: 15px;
    }
  }

</style>

<template>
  
  <div :id="'product-segment-item-' + product.item" class="ui segment" :class="{ loading }">

    <div class="ui grid no-margin no-padding">
      <div class="eight wide computer sixteen wide tablet sixteen wide mobile column no-margin no-padding">
        <div class="ui basic segment no-margin no-padding">
          <div class="bold" style="font-size: 13px;">
            {{ product.description }}
            <span v-if="$isApprover()" class="ui mini label m-l-5" :class="product.appPriceData.color">
              <i :class="product.appPriceData.icon"></i> {{ product.appPriceData.label }}
            </span>  
          </div>
        </div>
      </div>
      <div class="eight wide computer sixteen wide tablet sixteen wide mobile column no-margin no-padding">
        <div class="ui basic right aligned segment no-margin no-padding">
          <div class="ui mini label">
            <i :class="product.status.icon + ' ' + product.status.color"></i> {{ product.status.label }}
          </div>
        </div>
      </div>
    </div>

    <div class="ui divider"></div>

    <div class="ui form">
      <div class="fields">
        <div class="two wide field clickable product-segment-popup" :class="{ 'red text': product.quantityAlert }"
          :data-html="product.quantityPopupHtml">
          <label class="form-label" :class="{ 'red text': product.quantityAlert }">Quant. Total</label>
          <span>{{ $formatInteger(product.quantity) }}</span>
        </div>          
        <div class="two wide field" :class="{ clickable: !readonly }" @click="setAppPrice(product.stdPrice || product.minPrice)">
          <label class="form-label">Preço Padrão</label>
          <span>R$ {{ $formatCurrencyWith4Decimals(product.stdPrice || product.minPrice) }}</span>
        </div>
        <div class="two wide field">
          <label class="form-label">RG Mínimo</label>
          <span>{{ $formatCurrency(product.minRg) }}</span>
        </div>
        <div class="two wide field text" :class="getSugPriceClass(product)" @click="setAppPrice(product.sugPrice)">
          <label class="form-label text" :class="getSugPriceClass(product)">Preço Sugerido</label>
          <span>R$ {{ $formatCurrencyWith4Decimals(product.sugPrice) }}</span>
        </div>
        <div class="two wide field">
          <label class="form-label">Total Sugerido</label>
          <span>R$ {{ $formatCurrency(product.sugTotal) }}</span>
        </div>
        <div class="two wide field">
          <label class="form-label">Desconto Sugerido</label>
          <span v-html="formatSugDiscount"></span>
        </div>
        <div class="two wide field">
          <label class="form-label">Comissão Sug.</label>
          <span>{{ $formatCurrency(product.sugCommission) }}%</span>
        </div>
        <div v-if="$isApprover()" class="two wide field">
          <label class="form-label">RG Sugerido</label>
          <span>{{ $formatCurrency(product.sugRg) }}</span>
        </div>
      </div>
      <div class="fields">
        <div class="two wide field">
          <label class="form-label">Preço Aprovado</label>
          <span v-if="readonly">R$ {{ $formatCurrencyWith4Decimals(product.appPrice) }}</span>
          <input v-else class="money-four-dec" :value="appPrice" @blur="appPrice = $event.target.value">
        </div>
        <div class="two wide field">
          <label class="form-label">Total Aprovado</label>
          <span v-if="readonly">R$ {{ $formatCurrency(product.appTotal) }}</span>
          <input v-else class="money" :value="appTotal" @blur="appTotal = $event.target.value">
        </div>
        <div v-if="$isApprover()" class="two wide field">
          <label class="form-label">RG Aprovado</label>
          <span v-if="readonly">{{ $formatCurrency(product.appRg) }}</span>
          <input v-else :value="appRg" @blur="appRg = $event.target.value" placeholder="0,00">
        </div>
        <div class="two wide field">
          <label class="form-label">Diferença</label>
          <span v-if="readonly">{{ $formatCurrency(product.priceDiff) }}%</span>
          <input v-else :value="priceDiff" @blur="priceDiff = $event.target.value" placeholder="0,00">
        </div>
        <div class="two wide field">
          <label class="form-label">Comissão Aprov.</label>
          <span v-if="readonly">{{ $formatCurrency(product.appCommission) }}%</span>
          <input v-else class="money" :value="appCommission" @blur="appCommission = $event.target.value">
        </div>
        <div v-if="readonly && $isApprover()" class="two wide field">
          <label class="form-label">Comissão Fixa</label>
          <span>{{ product.isFixedCommission ? 'Sim' : 'Não' }}</span>
        </div>        
        <div class="four wide field">
          <label class="form-label">Desconto Aprovado</label>
          <span v-if="readonly" v-html="formatAppDiscount"></span>
          <input v-else :value="product.appDiscount" readonly="readonly">
        </div>        
      </div>      
      <div v-if="!readonly && $isApprover()" class="fields">
        <div class="sixteen wide field">
          <div class="ui checkbox product-segment-checkbox">
            <input type="checkbox" v-model="product.isFixedCommission">
            <label>Comissão Fixa</label>
          </div>
        </div>
      </div>
    </div>

    <button v-if="!readonly" :id="'btn-confirm-item-' + product.item" class="ui button m-t-20 m-b-15" 
      :class="{ 'disabled loading': saving }" @click="onConfirm()">
      <i class="checkmark blue icon"></i> Confirmar        
    </button>

  </div> 

</template>

<script>

  import QuotationService from "@/services/quotation-service"
  import { Input, Message } from "@/utils"

  export default {

    data() {
      return {
        loading: false,
        saving: false,
        product: {},        
      }
    },
    
    props: ["quotation", "item", "readonly"],

    created() {
      this.product = this.$cloneObject(this.item)
    },

    mounted() {
      
      $(".product-segment-popup").popup()
      $(".product-segment-checkbox").checkbox()
      
      if (!this.readonly)
        Input.maskCurrency()
    },

    computed: {

      formatSugDiscount() {
        // Mod20634-1: sempre exibir desconto sugerido
        if (this.product.stdPrice && Number(this.product.sugPrice) > Number(this.product.stdPrice)) {
          const n = Number(this.product.sugDiscount)
          if (!isNaN(n)) {
            return n < 0
              ? `<span class="red text">${this.product.sugDiscount}</span>`
              : String(this.product.sugDiscount)
          }
        }
        if (this.product.sugDiscTyped) {
          return QuotationService.formatDiscountFromTyped(this.product.sugDiscTyped)
        }
        if (this.product.discountCard || this.product.discountAdditional || this.product.discountExtra) {
          return QuotationService.formatDiscountBold(this.product.discountCard, this.product.discountAdditional, this.product.discountExtra)
        }
        return QuotationService.formatDiscountWithDef(this.product.sugDiscount, this.product.defDiscount)
      },

      formatAppDiscount() {
        // Mod20634-1: sempre exibir desconto aprovado
        if (!this.product.appPrice) return ''
        if (this.product.stdPrice && Number(this.product.appPrice) > Number(this.product.stdPrice)) {
          const n = Number(this.product.appDiscount)
          if (!isNaN(n)) {
            return n < 0
              ? `<span class="red text">${this.product.appDiscount}</span>`
              : String(this.product.appDiscount)
          }
        }
        if (this.product.appDiscTyped) {
          return QuotationService.formatDiscountFromTyped(this.product.appDiscTyped)
        }
        if (this.product.discountCard || this.product.discountAdditional || this.product.discountExtra) {
          return QuotationService.formatDiscountBold(this.product.discountCard, this.product.discountAdditional, this.product.discountExtra)
        }
        return QuotationService.formatDiscountWithDef(this.product.appDiscount, this.product.defDiscount)
      },

      appPrice: {
        get() {
          return Input.currencyWith4DecimalsToString(this.product.appPrice) 
        },
        set(value) {
          this.calculateAppPrice(Input.stringToCurrency(value))
        },
      },

      appTotal: {
        get() {
          return Input.currencyToString(this.product.appTotal) 
        },
        set(value) {

          const appTotal = Input.stringToCurrency(value)
          const appPrice = (appTotal / this.product.quantity)

          this.calculateAppPrice(appPrice)
        },
      },

      appRg: {
        get() {
          return Input.currencyWith4DecimalsToString(this.product.appRg) 
        },
        set(value) {

          const appRg = Input.stringToCurrency(value)

          this.calculateAppPriceFromRg(appRg)
        },
      },

      priceDiff: {
        get() {
          return Input.currencyToString(this.product.priceDiff) 
        },
        set(value) {

          if (!this.product.sugPrice)
            this.product.sugPrice = 0

          const diffPerc = Input.stringToCurrency(value)
          const diffValue = ((this.product.sugPrice * diffPerc) / 100)	
          const appPrice = (this.product.sugPrice + diffValue)

          this.calculateAppPrice(appPrice)
        },
      },

      appCommission: {
        get() {
          return Input.currencyToString(this.product.appCommission) 
        },
        set(value) {
          this.product.appCommission = Input.stringToCurrency(value)
        },
      },
    },

    methods: {

      getSugPriceClass(product) {

        let cls = product.appPriceData.color

        if (!this.readonly)
          cls += " clickable"

        return cls
      },

      setAppPrice(price) {

        if (this.readonly)
          return
          
        if (!this.product.appPrice) {
          
          this.product.appPrice = price

        } else {

          this.product.appPrice = 0          
          
          if (!this.product.isFixedCommission)
            this.product.appCommission = 0
        }

        this.calculateAppPrice(this.product.appPrice)
      },

      async calculateAppPrice(appPrice) {

        this.loading = true     

        try {

          const item = await QuotationService.calculateAppPrice(this.quotation, this.product, appPrice)          

          this.product = this.$cloneObject(item)

          $("#btn-confirm-item-" + this.product.item).focus()

        } catch (error) {
          this.$errorHandler(error)
        }

        this.loading = false
      },

      async calculateAppPriceFromRg(rg) {

        this.loading = true     

        try {

          const { codeCustomer, unitCustomer, isRetail } = this.quotation

          const appPrice = await QuotationService.getPriceFromRg({
            codeCustomer,
            unitCustomer,
            isRetail,
            rg,
            item: this.product,
          })

          await this.calculateAppPrice(appPrice)

        } catch (error) {
          this.$errorHandler(error)
        }

        this.loading = false
      },

      async onConfirm() {

        if (!this.product.appPrice) {
          Message.info("Informe o Preço Aprovado")
          return
        }

        this.saving = true
        this.loading = true

        try {

          await QuotationService.updateAppPrice({
            quotationId: this.quotation.id,
            item: this.product,
          })

          $("#product-segment-item-" + this.product.item).fadeOut(600, () => {
            this.$emit("onUpdate", this.product)
          })          
          
        } catch (error) {
          this.$errorHandler(error)
        }

        this.saving = false
        this.loading = false        
      },
    },
  }

</script>

